export const getAllLocations = (api, tokenType) => {
  return api.get("/location", { tokenType });
};
